import { getToolName, isToolUIPart, type UIMessage } from "ai";

function isPendingWriteToolPart(
  part: Extract<UIMessage["parts"][number], { toolCallId: string }>
): boolean {
  return (
    part.state === "input-available" ||
    part.state === "approval-requested" ||
    (part.state === "input-streaming" && Boolean(part.input))
  );
}

/** Last assistant message looks like a field table but has no pending write tool part. */
export function findTextOnlyWriteProposalMessageId({
  messages,
  messageTextContent,
  isWriteToolName,
  resolvedToolCallIds,
}: {
  messages: UIMessage[];
  messageTextContent: (message: UIMessage) => string;
  isWriteToolName: (toolName: string) => boolean;
  resolvedToolCallIds?: ReadonlySet<string>;
}): string | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (message.role !== "assistant") continue;
    const text = messageTextContent(message);
    if (!/\|\s*field\s*\|/i.test(text) && !/proposed value/i.test(text)) return null;
    const hasPendingWrite = message.parts.some((part) => {
      if (!isToolUIPart(part)) return false;
      if (!isWriteToolName(getToolName(part))) return false;
      if (resolvedToolCallIds?.has(part.toolCallId)) return false;
      return isPendingWriteToolPart(part);
    });
    if (hasPendingWrite) return null;
    return message.id;
  }
  return null;
}
